import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getRawSessionStorageItem } from 'src/services/storage/session';
import { LOCATION_REQUESTED_SESSION_STORAGE_KEY } from 'src/services/auth/session/hooks/utils/zillowSignIn/constants';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
import { createDatadogError } from 'src/services/datadog/utils/createDatadogError';

export type AuthErrorMetadata = {
    loginLocation: string | null | undefined;
    errorType: string;
};
export const AuthorizationCodeLoginFailureError = createDatadogError('AuthorizationCodeLoginFailure');

export const useOAuthErrorState = () => {
    const router = useRouter();
    useEffect(() => {
        const logDatadog = async () => {
            const location = getRawSessionStorageItem(LOCATION_REQUESTED_SESSION_STORAGE_KEY);
            await DatadogRUMService.Client.getInstance().addError(
                new AuthorizationCodeLoginFailureError('Authorization code login failed'),
                {
                    error: {
                        loginLocation: location,
                        errorType: router.query.error as string,
                    },
                }
            );
        };
        logDatadog();
    });
};
